// extracted by mini-css-extract-plugin
export var boldText = "_6o-4";
export var checkboxContainer = "_6o-6";
export var closeIcon = "_6o-i";
export var container = "_6o-0";
export var drawer = "_6o-8";
export var drawerContent = "_6o-9";
export var extraSmallText = "_6o-5";
export var fulfillmentGroupTable = "_6o-e";
export var largeText = "_6o-3";
export var loadingSpinnerContainer = "_6o-j";
export var mediumText = "_6o-2";
export var narrow = "_6o-f";
export var notificationLink = "_6o-l";
export var packageCheckIconContainer = "_6o-7";
export var slideoutHeaderActions = "_6o-g";
export var slideoutHeaderActionsShifted = "_6o-h";
export var slideoutHeaderContainer = "_6o-a";
export var slideoutModal = "_6o-c";
export var stickyHeaderWrapper = "_6o-b";
export var table = "_6o-k";
export var tableContainer = "_6o-d";
export var tertiaryText = "_6o-1";